import React from "react";
import "./SystemTab.css";
import {Button, Col, Container, Row} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import CamplaCoreService from "../../../../../services/CamplaCoreService";
import APIErrorHelper from "../../../../../helpers/APIErrorHelper";
import {faRedo} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCircleNotch} from "@fortawesome/fontawesome-free-solid";

class SystemTab extends React.Component {
  constructor(props) {
    super(props);

    this.loadLogs = (
        <div style={{textAlign: "center", marginBottom: "175px"}}>
          <h3>
            <FontAwesomeIcon icon={faCircleNotch} spin style={{color: "#FFFFFF"}}/>
          </h3>
        </div>
    );

    this.firstLoad = (
      <div style={{textAlign: "center", marginBottom: "175px"}}>
        <Button className="btn btn-green" onClick={() => this.loadData()}>
          <FontAwesomeIcon icon={faRedo} />
        </Button>
      </div>
    );

    this.state = {
      auditLogs: this.firstLoad,
      lastReload: new Date().toISOString(),
      apiError: null
    };

    this.colors = {
      30: '#000',
      31: '#A00',
      32: '#0A0',
      33: '#A50',
      34: '#00A',
      35: '#A0A',
      36: '#0AA',
      37: '#AAA',
      38: '#555',
      39: '#F55',
      310: '#5F5',
      311: '#FF5',
      312: '#55F',
      313: '#F5F',
      314: '#5FF',
      315: '#FFF'
    };

    this.loadData = this.loadData.bind(this);
  }


  highlightEscapeLinea(lines){
    return lines.map(line => {
      const lineParts = line.split(/- \[[0-9]*m/)
      const colorCode = lineParts[0].replace(/\\[/, "").substring(0,3).replace("m", "");
      if (lineParts.length > 1){
        if (typeof this.colors[colorCode] !== "undefined"){
          return <><span><b style={{color: this.colors[colorCode]}}>{lineParts[0].replace(/\[[0-9]*m/, "")}</b> - {lineParts[1]}</span><br /></>
        }else{
          return <><span><b>{lineParts[0].replace(/\[[0-9]*m/, "")}</b> - {lineParts[1]}</span><br /></>
        }
      }else{
        return <><span>{line}</span><br /></>
      }
    })
  }

  async loadData() {
    let oldLogs = this.state.auditLogs;
    try {
      this.setState({auditLogs: this.loadLogs});
      const {auditLogs} = await CamplaCoreService.getAllAuditLogs();
      const logs = auditLogs
          .filter(line => line !== "")
          .reverse()
          .map(line => {
            const lineParts = line.split(" - ");
            if (lineParts.length > 1){
              if (lineParts[0].indexOf(" [ERROR] ") !== -1){
                return <><span><b style={{color: "red"}}>{lineParts[0]}</b> - {lineParts[1]}</span><br /></>
              }else if (lineParts[0].indexOf(" [WARN] ") !== -1) {
                return <><span><b style={{color: "yellow"}}>{lineParts[0]}</b> - {lineParts[1]}</span><br /></>
              }else{
                return <><span><b style={{color: "green"}}>{lineParts[0]}</b> - {lineParts[1]}</span><br /></>
              }
            }else{
              return <><span>{line}</span><br /></>
            }
          });
      this.setState({auditLogs: logs, lastReload: new Date().toISOString()});
    } catch (err) {
      this.setState({auditLogs: oldLogs});
      //Todo: Add correct errors according to documentation
      this.setState({
        apiError: APIErrorHelper.getError(
            err,
            () => this.setState({ apiError: "" }),
            {},
            this.props.t
        )
      });
    }
  }

  render(){
    const { t } = this.props;
    return (
        <Container className="ml-0 mr-0 pl-0 pr-0 pt-3">
          <Row>
            <Col>
              <h4>{t("Dashboard.AdminDashboard.SystemTab.AuditLogs")}</h4>
            </Col>
            <Col>
              <div style={{float: "right", fontSize: "10pt"}}>
                ({this.state.lastReload}) <FontAwesomeIcon icon={faRedo} onClick={() => this.loadData()}/>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div style={{
                height: "400px",
                backgroundColor: "black",
                color: "white",
                fontSize: "9pt",
                overflow: "auto",
                display: "flex",
                flexDirection: "column-reverse"
              }}>
                {this.state.auditLogs}
              </div>
            </Col>
          </Row>
        </Container>
    );
  }
}

export default withTranslation()(SystemTab);
